import { Alert, Collapsible } from "@simplicity/ui";
import { TriangleAlert } from "lucide-react";
import { useContext } from "react";
import type { Schedules, TableConfig } from "../tables/types";
import { auditSchedules } from "./scheduleAudit";
import { ScheduleAuditContext } from "./ScheduleAuditContext";

/**
 * SIM-3044: defined tables that no schedule picks up. A warning, not an error — staging a
 * table before scheduling it is a legitimate step, so this informs rather than blocks.
 */
export function UnscheduledTablesNotice({
  tables,
  schedules,
}: {
  tables: TableConfig[];
  schedules: Schedules;
}) {
  const connector = useContext(ScheduleAuditContext);
  const { unscheduledTables: names } = auditSchedules(tables, schedules, connector);
  if (names.length === 0) return null;

  const lead =
    names.length === 1
      ? "1 table isn't on any schedule, so it won't run."
      : `${names.length} tables aren't on any schedule, so they won't run.`;
  // A connector can list dozens of names, so they wait behind a disclosure.
  return (
    <Alert variant="warning" className="mt-2 flex items-start gap-2">
      <TriangleAlert className="mt-0.5 h-4 w-4 shrink-0 text-warning" aria-hidden="true" />
      <div>
        <p>{lead}</p>
        <Collapsible trigger="See tables" className="mt-1">
          <p className="font-mono">{names.join(", ")}</p>
        </Collapsible>
      </div>
    </Alert>
  );
}
